import { Utility } from "../utility.js"

export class LevelTitle extends Phaser.Scene {
    constructor(key, level, clazz) {
        super({key: key });
        this._prefix = key.split("-")[0]
        this._level = level
        this._clazz = clazz
    }
    preload() {
        this.load.image("level-title-background","assets/level-title-background.jpg");
        this.load.image(`${this._prefix}-title-title`,`assets/${this._clazz.info.key}/title-header.png`);
        this.load.image(`${this._prefix}-title-logo`,`assets/${this._clazz.info.key}/intro-logo.png`);
        this.load.image("help-icon-img","assets/help-icon.png")
    }
    create() {
        const background = this.add.image(0, 0, "level-title-background").setOrigin(0);
        background.setDisplaySize(this.sys.canvas.width, this.sys.canvas.height);

        let board = this.add.container(this.cameras.main.centerX, 100).setScale(1.5);
        board.add(this.physics.add.staticImage(0,20,`${this._prefix}-title-title`).setScale(0.5));
        const description = this._clazz.info.description
        board.add(Utility.make.text(this, -185, 90, `${description}`, {
            fontSize: `15px`,
            align: "center",
            wordWrap: { width: 400, useAdvancedWrap: true }
        }))
        board.add(this.physics.add.staticImage(0, 240, `${this._prefix}-title-logo`).setScale(0.5))

        this.add.image(this.sys.canvas.width - 150, this.sys.canvas.height - 70, "help-icon-img").setScale(.5)
        Utility.make.text(this, this.sys.canvas.width - 270, this.sys.canvas.height - 140, 'Hint: Click the help icon in any level for instructions.', {
            fontSize: `19px`,
            align: "center",
            wordWrap: { width: 250, useAdvancedWrap: true }
        }).setResolution(2)

        let home = Utility.make.button("HOME", {scene: this, x: -70, y: 310, color: 0xffa500, hover: 0xcca500}).setScale(0.7)
        let start = Utility.make.button("START", {scene: this, x: 70, y: 310}).setScale(0.7)
        board.add([home, start])
        home.on('pointerdown', ()=> this._level.home())
        start.on('pointerdown', ()=> this._level.play.level())
    }
}